import * as React from "react";

import { IOrderLineItemConnection } from "~/graphql/queries/order/orderByName";
import styled from "~/styled";

interface IProps {
  orderLineItems: IOrderLineItemConnection;
}

const Wrapper = styled.div`
  display: grid;
  grid-template-areas: "image product-title . quantity";
  grid-auto-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  margin: 16px;
`;

const Image = styled.div`
  grid-area: image;
  max-width: 80px;
  > img {
    width: 100%;
  }
`;

const ProductTitle = styled.div`
  grid-area: product-title;
`;

const ProductVariantTitle = styled.div`
  color: grey;
`;

const Quantity = styled.div`
  grid-area: quantity;
`;

class NexusProductsDetail extends React.Component<IProps> {
  public render() {
    const { orderLineItems } = this.props;

    return (
      <>
        {orderLineItems.edges.map(({ node: orderLineItem }) => {
          const {
            id,
            quantity,
            productTitle,
            productVariantTitle,
            imageSrc,
            shopProduct: {
              shopifyProduct: { title, productImages }
            }
          } = orderLineItem;

          const imageSource =
            imageSrc || productImages.length !== 0 ? productImages[0].src : "";

          return (
            <Wrapper key={id}>
              <>
                <Image>
                  <img src={imageSource} alt={productTitle} />
                </Image>
                <ProductTitle>
                  {productTitle || title}
                  <ProductVariantTitle>
                    {productVariantTitle !== "Default Title" &&
                      productVariantTitle}
                  </ProductVariantTitle>
                </ProductTitle>
                <Quantity>x{quantity}</Quantity>
              </>
            </Wrapper>
          );
        })}
      </>
    );
  }
}

export default NexusProductsDetail;



// WEBPACK FOOTER //
// ./src/components/TrackTrace/NexusProductsDetail.tsx